import { FC, useState } from "react";
import { Popover } from "antd";

import { ReactComponent as LogoDM } from "assets/images/auth/logoDM.svg";
import { ReactComponent as LogoPP } from "assets/images/auth/logoPP.svg";
import { ReactComponent as LogoGPS } from "assets/images/auth/logoGPS.svg";
import { ReactComponent as LogoHC } from "assets/images/auth/logoHC.svg";
import { ReactComponent as LogoAPM } from "assets/images/auth/logoAPM.svg";

import { ReactComponent as LogoutIcon } from "assets/images/app-switcher/logout.svg";
import { ReactComponent as PersonIcon } from "assets/images/app-switcher/person.svg";
import { ReactComponent as ShifterIcon } from "assets/images/app-switcher/shifter.svg";
import { ReactComponent as ArrowDownIcon } from "assets/images/app-switcher/arrow-down.svg";

import defaultPictureSrc from "assets/svg/avatar.svg";
import arootahSrc from "assets/images/app-switcher/arootah.png";

import {
  Box,
  Wrapper,
  AppItem,
  AppLink,
  AppItemTitle,
  Toggle,
  ProfileImg,
  ProfileUser,
  ProfileSection,
  FooterSection,
  LogoutButton,

  SwitcherWrap,
  ShifterWrap,
  ShifterText,

  ActiveBadge
} from "./styled";

// @ts-ignore
import customStyles from "./global.module.scss";

// @ts-ignore
import { useProject, useAllocatorAccess } from "utils/utility";

// @ts-ignore
import { ALLOCATOR_TOOL, PROJECT_PLANNER } from "utils/routes";

// @ts-ignore
import { getEnvironment } from "utils/constants";

export const getPath = () => {
  const environment = getEnvironment();

  switch (environment) {
    case 'staging':
      return {
        gmURL: 'goals-staging.arootah.com',
        hcURL: 'app-staging.arootah.com',
        authURL: 'auth-staging.arootah.com',
      };
    case 'staging-ocean':
      return {
        gmURL: 'arootah-goal-manager-staging-ggg97.ondigitalocean.app',
        hcURL: 'arootah-habit-manager-staging-itze9.ondigitalocean.app',
        authURL: 'arootah-user-service-staging-ev7t2.ondigitalocean.app',
      };
    case 'production-ocean':
      return {
        gmURL: 'arootah-goal-manager-prod-g2l9r.ondigitalocean.app',
        hcURL: 'arootah-habit-manager-production-re22a.ondigitalocean.app',
        authURL: 'arootah-user-service-production-6y4ss.ondigitalocean.app',
      };
    case 'production':
    default:
      return {
        gmURL: 'goals.arootah.com',
        hcURL: 'app.arootah.com',
        authURL: 'auth.arootah.com',
      };
  }
};

interface IProps {
  photo?: string;
  name?: string;
  app: string;
  onLogout?: () => void;
}

const AppSwitcher: FC<IProps> = ({ photo, name, app, onLogout }) => {
  const { project } = useProject();
  const isAllocatorUser = useAllocatorAccess();

  const [open, setOpen] = useState(false);

  const activeProject = project || app || null;

  const isDM = activeProject === "decision-manager";
  const isPP = activeProject === "project-planner";
  const isAT = activeProject === ALLOCATOR_TOOL;

  const { hcURL, gmURL, authURL } = getPath();

  const handleHide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const profilePath = isPP ? "/project-planner/profile" : isAT ? "/allocator-tool/profile" : "/decision-manager/profile";

  return (
    <Popover
      overlayClassName={customStyles.popover}
      placement="bottomLeft"
      content={
        <Box>
          <Wrapper>
            <ProfileSection>
              <ProfileImg src={photo || defaultPictureSrc} />
              <ProfileUser>{name || "Guest"}</ProfileUser>
            </ProfileSection>

            <AppItem to="/project-planner/profile" onClick={handleHide}>
              <PersonIcon />
              <AppItemTitle>My profile</AppItemTitle>
            </AppItem>

            <SwitcherWrap>
              <ShifterWrap>
                <ShifterIcon />
                <ShifterText>Switch Apps</ShifterText>
              </ShifterWrap>

              <AppLink href={`https://${authURL}`}>
                <img src={arootahSrc} alt="" />
                <AppItemTitle $bold>Arootah Home</AppItemTitle>
              </AppLink>
            </SwitcherWrap>

            <AppLink href={`https://${gmURL}`}>
              <LogoGPS />
              <AppItemTitle>Goal Manager</AppItemTitle>
              
            </AppLink>

            <AppLink href={`https://${gmURL}/time-manager`}>
              <LogoAPM />
              <AppItemTitle>Time Manager</AppItemTitle>
            </AppLink>

            <AppLink href={`https://${hcURL}`}>
              <LogoHC />
              <AppItemTitle>Habit Manager</AppItemTitle>
            </AppLink>

            <AppItem to={isAllocatorUser ? `/${ALLOCATOR_TOOL}` : "/decision-manager"} onClick={handleHide} $active={isDM || isAT}>
              <LogoDM />
              <AppItemTitle>{isAllocatorUser ? "Allocator Tool" : "Decision Manager"}</AppItemTitle>
              {(isDM || isAT) ? <ActiveBadge>Active</ActiveBadge> : null}
            </AppItem>

            <AppItem to={PROJECT_PLANNER} onClick={handleHide} $active={isPP}>
              <LogoPP />
              <AppItemTitle>Project Manager</AppItemTitle>
              {isPP ? <ActiveBadge>Active</ActiveBadge> : null}
            </AppItem>

            <FooterSection>
              <LogoutButton onClick={onLogout}>
                <LogoutIcon />
                Log Out
              </LogoutButton>
            </FooterSection>
          </Wrapper>          
        </Box>
      }
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
    >
      <Toggle>
        <ProfileImg src={photo || defaultPictureSrc} $shadow />
        <ArrowDownIcon />
      </Toggle>
    </Popover>
  );
};

export default AppSwitcher;
